import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import {
	createApiKey,
	deleteApiKey,
	listApiKeys,
} from "../../api/commands/integrations";
import { CopyTarget } from "./model";

export const Message = defineMessageUnion({
	ClickedCopy: { target: CopyTarget },
	CopyFeedbackExpired: { target: CopyTarget },
	CompletedListKeys: { generation: S.Number, result: listApiKeys.Result },
	ChangedKeyDescription: { value: S.String },
	ClickedCreateKey: {},
	CompletedCreateKey: { generation: S.Number, result: createApiKey.Result },
	ClickedDeleteKey: { id: S.String },
	CompletedDeleteKey: {
		id: S.String,
		generation: S.Number,
		result: deleteApiKey.Result,
	},
});
export type Message = typeof Message.Type;
